import React, { Component } from "react";

// Styles for the overlay image
const overlayStyles = {
  position: "absolute",
  filter: "blur(1px)",
  transition: "opacity ease-in 1000ms",
  clipPath: "inset(0)",
  top: 0,
  width: "100%",
  left: 0,
  height: "auto",
};

const highResImageStyle = {
  // height: "auto",
  top: 0,
  width: "100%",
  aspectRatio: "1.333333",
};

class ProgressiveImage extends Component {
  state = { highResImageLoaded: false };

  handleHighResImageLoad = () => {
    this.setState({ highResImageLoaded: true });
  };

  handleSmallImageLoad = () => {
    const { setSmallImageLoaded } = this.props;
    if (setSmallImageLoaded) setSmallImageLoaded(true);
  };

  render() {
    const {
      overlaySrc,
      onClick,
      ref,
      smallImageRef,
      noRelativeParent,
      smallStyle,
      ...restProps
    } = this.props;
    const { highResImageLoaded } = this.state;

    return (
      <>
        <img
          {...restProps}
          onLoad={this.handleHighResImageLoad}
          ref={(img) => {
            this.highResImage = ref ?? img;
          }}
          src={this.props.src}
          style={highResImageStyle}
          onClick={onClick}
        />
        <img
          {...restProps}
          src={overlaySrc}
          style={{
            ...overlayStyles,
            opacity: highResImageLoaded ? "0" : undefined,
            ...smallStyle,
          }}
          ref={smallImageRef}
          onClick={onClick}
          onLoad={this.handleSmallImageLoad}
        />
      </>
    );
  }
}

export default ProgressiveImage;
